module.exports = __webpack_public_path__ + "img/audio.4a5ac585.png";